import React from 'react';
import { ElementConfigType } from '../store/PageEditorStore';
import { MyComponentType } from '@/pages2/DetailedDescription/component-factory/component-types';
import { ComponentIdEnum } from '@/pages2/DetailedDescription/component-factory/ComponentIdEnum';

type Props = ElementConfigType;

export const TextTitleComponent: MyComponentType<Props> = (props: Props) => {
  const { styles, privateSchema, config, parentNodeIsBody } = props;
  return (
    <div style={Object.assign(parentNodeIsBody ? { paddingTop: 16, paddingBottom: 16 } : {}, styles)}>
      <h2
        style={{
          fontSize: privateSchema?.fontSize,
          fontWeight: privateSchema?.fontWeight,
          color: privateSchema?.color,
          textAlign: privateSchema?.textAlign,
          lineHeight: `${privateSchema?.lineHeight}px`,
        }}
      >
        {privateSchema?.text || config?.text}
      </h2>
      {privateSchema?.isShowUnderline && privateSchema?.textAlign === 'left' && (
        <div className="w-12 h-1 rounded-sm bg-black mt-4" />
      )}
    </div>
  );
};

TextTitleComponent.definition = {
  // id: 'text-title-component',
  id: ComponentIdEnum.TEXT_TITLE_COMPONENT,
  name: '标题文本组件_1',
  icon: 'https://cdn.resource.youniverse.cc/d2c-app-dev/dIVTg-dEwgXAOViujW2tP.png?image_process=resize,w_200',
  position: 6, // 显示顺序
  config: {
    text: 'Why Choose FEZiBO?',
  },
  styles: {},
  privateSchema: {
    text: 'Why Choose FEZiBO?',
    fontSize: 30, // 16
    fontWeight: 600,
    // eslint-disable-next-line @iceworks/best-practices/recommend-add-line-height-unit
    lineHeight: 36, // 24
    isShowUnderline: true,
    textAlign: 'left',
  },
};
